/***************************************************************************/
"use client";
/***************************************************************************/

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";

const TooltipArrow = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Arrow>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow> & {
    fillBackground?: string;
    fillBorder?: string;
  }
>(({ className, fillBackground, fillBorder, ...props }, ref) => {
  return (
    <React.Fragment>
      <TooltipPrimitive.Arrow
        ref={ref}
        className={`h-1.5 w-3 ${fillBorder ?? "fill-border"} ${className ?? ""}`}
        {...props}
      />
      <TooltipPrimitive.Arrow
        className={`h-1.5 w-3 ${fillBackground ?? "fill-gray-50"} -mt-[1.5px] ${className ?? ""}`}
        {...props}
      />
    </React.Fragment>
  );
});
TooltipArrow.displayName = "TooltipArrow";

export { TooltipArrow };
